import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from 'src/app/state/app.selectors';
import * as fromCommunityGrant from './community-grant.reducers';

export interface CommunityGrantState {
    stateData: fromCommunityGrant.State;
}

export interface State extends fromRoot.AppState {
    communityGrant: CommunityGrantState;
}

export const reducers = {
    stateData: fromCommunityGrant.reducer
};

export const selectCommunityGrantState = createFeatureSelector<CommunityGrantState>('communityGrant');

export const selectCommunityGrantStateData = createSelector(selectCommunityGrantState, (state: CommunityGrantState) => state.stateData);

export const getCommunityGrantState = createSelector(selectCommunityGrantStateData, fromCommunityGrant.getStateData);

export const getCommunityGrantScreenError = createSelector(selectCommunityGrantStateData, fromCommunityGrant.getError);

export const getCommunityGrantScreenPending = createSelector(selectCommunityGrantStateData, fromCommunityGrant.getPending);